module.exports = __webpack_public_path__ + "5c6f8b5d76f2ac6c8562c37cbf475a8e.jpg";